import { type StateCreator } from 'zustand';

import { type CreditUsageState } from '~/components/CreditUsageMeter/types';
import { type CreditUsageAlertType, getDismissedCreditUsageAlertStorageKey } from '~/hooks/creditUsageAlerts/utils';

export type DismissedCreditUsageAlertSlice = {
  dismissedAlerts: Record<string, { cycleEndingAt: string }>;
  dismiss: (args: {
    alertType: CreditUsageAlertType;
    creditUsageState: CreditUsageState;
    nextCycleStartAt: string;
    workspaceId: string;
  }) => void;
};

export const createDismissedCreditUsageAlertSlice =
  (): StateCreator<DismissedCreditUsageAlertSlice, [], [], DismissedCreditUsageAlertSlice> => (set, get) => ({
    dismissedAlerts: {},
    dismiss: ({ alertType, creditUsageState, nextCycleStartAt, workspaceId }) => {
      const { dismissedAlerts } = get();

      set({
        dismissedAlerts: {
          ...dismissedAlerts,
          [getDismissedCreditUsageAlertStorageKey({ workspaceId, alertType, creditUsageState })]: {
            cycleEndingAt: nextCycleStartAt,
          },
        },
      });
    },
  });
